import './infos.scss'

function Infos(){
    return(
      <section id="infos">
          <h2 className="fs-40">À propos</h2>
          <article className="pres">
              <p><span className="marge"></span>
                <strong>Passionné de travaux techniques et manuels</strong>, je me suis d'abord orienté vers le développement web et je cherche désormais à approfondir mes compétences techniques pour me spécialiser à terme dans les <strong>systèmes énergétiques & bâtiments connectés</strong>.
              </p>
              <p><span className="marge"></span>
                Ma formation en développement web m'a <strong>habitué à la logique, à la résolution de problèmes complexes et à la justesse méthodologique</strong>, des compétences qui constituent <strong>des atouts que je souhaite mettre au service de vos équipes</strong>.
              </p>
              <p><span className="marge"></span>
                <strong>Consciencieux et curieux</strong>, j'apprécie les environnements où la qualité d'exécution est primordiale. <strong>Ma capacité d'adaptation et mon autonomie me permettront de monter en compétences rapidement</strong> au contact de vos techniciens expérimentés.
              </p>
          </article>
        </section>
    )
}
export default Infos